import { buildLineMarkers } from "@/lib/diff/codeRenderingCommon.ts"
import { MarkerType } from "@/lib/diff/markerType.ts"
import { LineMarker, TextRangeImpl } from "@/lib/diff/misc.ts"
import { filterNotNull, isNotNull, mapNotNull } from "@/lib/std.ts"

import type {
  InlineDiffLine,
  SyntaxMarkup,
  SyntaxMarkupType,
  TextRange as TextRangeLegacy
} from "@/lib/client/generated/TypeDefinitions.ts"


export function getDiffLineMarkers(line: InlineDiffLine) {
  const lineMarkers: LineMarker[] = []

  lineMarkers.push(...buildLineMarkers(MarkerType.DIFF_ADDED, textRange(line.inserts || [])))
  lineMarkers.push(...buildLineMarkers(MarkerType.DIFF_DELETED, textRange(line.deletes || [])))
  lineMarkers.push(...buildLineSyntaxMarkers(filterNotNull(line.syntax || [])))

  return lineMarkers
}

function textRange(items: (TextRangeLegacy | null)[]): TextRangeImpl[] {
  return filterNotNull(items).map(TextRangeImpl.from)
}

function buildLineSyntaxMarkers(markers: SyntaxMarkup[]): LineMarker[] {
  if (!markers || markers.length === 0) {
    return []
  }

  return mapNotNull(markers, buildLineSyntaxMarker)
}

function buildLineSyntaxMarker(marker: SyntaxMarkup): LineMarker | null {
  const type = isNotNull(marker.type) ? syntaxToMarkerType[marker.type] : null
  const range = marker.range

  if (isNotNull(type) && range.length > 0) {
    return new LineMarker(type, range)
  }

  return null
}

const syntaxToMarkerType: Record<SyntaxMarkupType, MarkerType | null> = {
  COMMENT: MarkerType.COMMENT,
  NUM_LITERAL: MarkerType.NUM_LITERAL,
  STRING_LITERAL: MarkerType.STRING_LITERAL,
  KEYWORD: MarkerType.KEYWORD,
  DECLARATION: MarkerType.DECLARATION,
  PARAMETER_ASSIGNMENT: MarkerType.PARAMETER_ASSIGNMENT,

  // Identifiers.
  IDENTIFIER: MarkerType.IDENTIFIER,
  INVOCATION: MarkerType.INVOCATION,
  DSL: MarkerType.DSL,
  IDENTIFIER_TYPE: MarkerType.IDENTIFIER_TYPE,
  IDENTIFIER_DECLARATION: MarkerType.IDENTIFIER_DECLARATION,

  // Annotations and preprocessor.
  ANNOTATION: MarkerType.ANNOTATION,
  INLINE_ANNOTATION: MarkerType.INLINE_ANNOTATION,
  PREPROCESSOR_ANNOTATION: MarkerType.PREPROCESSOR_ANNOTATION,
  PREPROCESSOR_MESSAGE: MarkerType.PREPROCESSOR_MESSAGE,

  // Markup markup
  KEY: MarkerType.KEY,
  TAG: MarkerType.TAG,

  // Special markup
  HIGHLIGHT: MarkerType.HIGHLIGHT,
  CODE_FOLD: MarkerType.CODE_FOLD,
  SKIP: null
} as const